import { render } from "./MfToolbar.vue?vue&type=template&id=08d4a06f&scoped=true"
import script from "./MfToolbar.vue?vue&type=script&lang=js"
export * from "./MfToolbar.vue?vue&type=script&lang=js"

import "./MfToolbar.vue?vue&type=style&index=0&id=08d4a06f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d4a06f"]])

export default __exports__